<template>
  <span
      x-small
      class="ai-visibility-refresh-chip"
      :class="chipClasses"
  >
    <span
        v-if="showIcon"
        class="material-icons-outlined ai-visibility-refresh-chip__icon"
    >
      {{ iconName }}
    </span>
    <span class="ai-visibility-refresh-chip__label">{{ label }}</span>
  </span>
</template>

<script>
const REFRESH_LABELS = {
  weekly: 'WEEKLY',
  monthly: 'MONTHLY',
  once: 'ONE-TIME',
}

export default {
  name: 'AiVisibilityRefreshChip',
  props: {
    refreshFrequency: {
      type: String,
      default: 'weekly',
    },
    status: {
      type: String,
      default: 'active',
    },
  },
  computed: {
    label() {
      const frequency = this.refreshFrequency || 'weekly'
      return REFRESH_LABELS[frequency] || frequency.toUpperCase()
    },
    isActive() {
      return this.status === 'active'
    },
    isOneTime() {
      return this.refreshFrequency === 'once'
    },
    chipClasses() {
      return {
        'ai-visibility-refresh-chip--inactive': !this.isActive,
        'ai-visibility-refresh-chip--one-time': this.isOneTime,
        'ai-visibility-refresh-chip--weekly': this.refreshFrequency === 'weekly',
        'ai-visibility-refresh-chip--monthly': this.refreshFrequency === 'monthly',
      }
    },
    showIcon() {
      return !this.isActive || !this.isOneTime
    },
    iconName() {
      return this.isActive ? 'refresh' : 'do_disturb'
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-refresh-chip {
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  padding: 3px 8px;
  text-transform: uppercase;
  margin-top: 5px;
  border-radius: 999px;
  display: flex;
}

.ai-visibility-refresh-chip__icon {
  font-size: 13px;
  line-height: 1;
  margin-right: 3px;
}

.ai-visibility-refresh-chip__label {
  line-height: 1;
  font-weight: 500;
  font-size: 12px;
}

.ai-visibility-refresh-chip--one-time {
  background: var(--v-gray10Color-base);
  color: var(--v-gray36Color-base);
}

.ai-visibility-refresh-chip--inactive {
  background: var(--v-gray10Color-base) !important;
  color: var(--v-gray36Color-base) !important;

  .ai-visibility-refresh-chip__label {
    text-decoration: line-through;
  }
}

.ai-visibility-refresh-chip--weekly {
  background: var(--v-link9Color-base);
  color: var(--v-link3Color-base);
}

.ai-visibility-refresh-chip--monthly {
  background: var(--v-green10Color-base);
  color: var(--v-green8Color-base);
}

</style>
